//App
import { EnvType } from "./types/envType";
import gatewayConfig from "./gatewayConfig";
import { EnvironmentSettings } from "../../../utility/EnvironmentHelper";
import { EnvironmentTypes } from "../../../utility/Settings";

const env: EnvType = {
    serviceHost: gatewayConfig.local.serviceHost,
    identityHost: gatewayConfig.local.identityHost,
    clientId: gatewayConfig.local.clientId
};

if (EnvironmentSettings().environment === EnvironmentTypes.local) {
    env.serviceHost = gatewayConfig.local.serviceHost;
    env.identityHost = gatewayConfig.local.identityHost;
    env.clientId = gatewayConfig.local.clientId;
}

if (
   // EnvironmentSettings().environment === EnvironmentTypes.local ||
    EnvironmentSettings().environment === EnvironmentTypes.dev
) {
    env.serviceHost = gatewayConfig.dev.serviceHost;
    env.identityHost = gatewayConfig.dev.identityHost;
    env.clientId = gatewayConfig.dev.clientId;
}

if (
    //EnvironmentSettings().environment === EnvironmentTypes.local ||
    EnvironmentSettings().environment === EnvironmentTypes.qa
) {
    env.serviceHost = gatewayConfig.qa.serviceHost;
    env.identityHost = gatewayConfig.qa.identityHost;
    env.clientId = gatewayConfig.qa.clientId;
}

if (EnvironmentSettings().environment === EnvironmentTypes.sandbox) {
    env.serviceHost = gatewayConfig.sandbox.serviceHost;
    env.identityHost = gatewayConfig.sandbox.identityHost;
    env.clientId = gatewayConfig.sandbox.clientId;
}

if (EnvironmentSettings().environment === EnvironmentTypes.staging) {
    env.serviceHost = gatewayConfig.staging.serviceHost;
    env.identityHost = gatewayConfig.staging.identityHost;
    env.clientId = gatewayConfig.staging.clientId;
}

if (EnvironmentSettings().environment === EnvironmentTypes.prod
) {
    env.serviceHost = gatewayConfig.prod.serviceHost;
    env.identityHost = gatewayConfig.prod.identityHost;
    env.clientId = gatewayConfig.prod.clientId;
}

export default env;
